import LiveHighcharts from './LiveHighcharts'

patchWindow()

function patchWindow(): void {
    Object.defineProperty(globalThis, 'LiveHighcharts', {
        configurable: true,
        enumerable: true,
        value: LiveHighcharts
    })
}
